import { Box, Button, Card, Text } from "@mantine/core";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export type SaveableCardStatus = "idle" | "dirty" | "saving" | "saved";

export type SaveableCardProps = {
  title: string;
  description: string;
  children: ReactNode;
  status: SaveableCardStatus;
  onSave: () => void;
};

export const SaveableCard = ({
  title,
  description,
  children,
  status,
  onSave,
}: SaveableCardProps) => {
  const { t } = useTranslation("forms");

  return (
    <Card p="s5" pb="s8">
      <Box
        display="flex"
        pb="s4"
        mb="s4"
        style={{
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid var(--mantine-color-gray-2)",
        }}
      >
        <Box>
          <Text variant="body" fw="600" mb="s1">
            {title}
          </Text>
          <Text variant="caption" fw="500">
            {description}
          </Text>
        </Box>
        {(status === "dirty" || status === "saving") && (
          <Button size="sm" loading={status === "saving"} onClick={onSave}>
            {t("components.saveableCard.save")}
          </Button>
        )}
        {status === "saved" && (
          <Box
            bd="1px solid var(--mantine-color-green-2)"
            bdrs="xl"
            py="s2"
            px="s4"
            bg="var(--mantine-color-emerald-0)"
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Text variant="caption" fw="600" c="var(--mantine-color-emerald-7)">
              {t("components.saveableCard.saved")}
            </Text>
          </Box>
        )}
      </Box>
      {children}
    </Card>
  );
};
